import cn from 'clsx'

// Components
import { Button, Tooltip } from '@tracklib/kit'

// Utils
import styles from './footer.css'

type FooterProps = {
  handlePrevious: (values: Record<string, unknown>) => unknown
  handleNext: (values: Record<string, unknown>) => unknown
  handleBackToSlides: () => void
  isLastStep?: boolean
  stepData: {
    stepIndexNumber: number
    totalSteps: number
  }
  values: Record<string, unknown>
}

const Footer = (props: FooterProps): JSX.Element => {
  const {
    handlePrevious,
    handleNext,
    handleBackToSlides,
    isLastStep,
    values,
    stepData: { stepIndexNumber, totalSteps },
  } = props

  return (
    <div className={styles.footer}>
      <div className={styles.backBtns}>
        {stepIndexNumber > 0 && (
          <Button className={styles.btn} variant="outline" onClick={() => handlePrevious(values)}>
            Previous
          </Button>
        )}
        {stepIndexNumber > 14 && (
          <span data-tooltip-wrapper>
            <Button className={cn(styles.btn, styles.btnMargin, styles.hideBtn)} variant="outline" onClick={() => handleBackToSlides()}>
              Back to Presentation
            </Button>
            <Tooltip type="light" className={styles.tooltip}>
              Don&apos;t worry, your info will still be here when you get back
            </Tooltip>
          </span>
        )}
      </div>
      <span>{`${stepIndexNumber - 1}/${totalSteps - 2}`}</span>
      <Button className={styles.btn} onClick={() => handleNext(values)}>
        {isLastStep ? 'Submit' : 'Next'}
      </Button>
    </div>
  )
}

export default Footer
